<div class="modal-header">
  <h5 class="modal-title">Office Invites</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="reviewLater()"></button>
</div>

<div class="modal-body p-4">
  <p class="text-muted mb-4">
    You have pending invites waiting for your response.
  </p>

  <div class="pending-invite-list">
    <div class="pending-invite-card" *ngFor="let invite of invites">
      <div class="pending-invite-card-top">
        <div>
          <div class="pending-invite-group">{{ invite.groupName }}</div>
          <div class="pending-invite-meta" *ngIf="invite.invitedByName">
            Invited by {{ invite.invitedByName }}
          </div>
        </div>

        <span class="badge rounded-pill text-bg-dark" *ngIf="invite.addAsGroupAdmin || invite.addAsSuperGroupAdmin">
          {{ invite.addAsSuperGroupAdmin ? 'All offices' : 'Office admin' }}
        </span>
      </div>

      <div class="pending-invite-meta mt-2" *ngIf="invite.emailTargets?.length">
        Sent to {{ invite.emailTargets.join(', ') }}
      </div>

      <div class="pending-invite-meta" *ngIf="invite.invitedAt">
        Sent {{ invite.invitedAt | date: 'd MMM yyyy, h:mm a' }}
      </div>

      <div class="pending-invite-actions mt-3">
        <button
          type="button"
          class="btn btn-outline-dark"
          [disabled]="processingInviteId === invite.id"
          (click)="decline(invite)"
        >
          Decline
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="processingInviteId === invite.id"
          (click)="accept(invite)"
        >
          <ng-container *ngIf="processingInviteId === invite.id; else acceptLabel">
            <fa-icon [icon]="faSpinnerThird" animation="spin" class="me-2"></fa-icon>
            Saving...
          </ng-container>
          <ng-template #acceptLabel>Accept</ng-template>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark me-auto" (click)="reviewLater()">Review later</button>
</div>
